import React from 'react';
import Chart from 'react-apexcharts';
import GraphLoader from './GraphLoader';

const GraphChartComponent = ({ data }) => {
    const loading = !data?.length;
    if (loading) {
        return <GraphLoader />;
    }
    const options = {
        chart: {
            type: 'line',
            height: 364,
            animations: { enabled: false },
            dropShadow: { enabled: true, opacity: 0.1, blur: 7, left: -7, top: 7 },
            toolbar: { show: true },
        },
        markers: { size: 4 },
        dataLabels: { enabled: false },
        stroke: { width: 3, curve: 'straight' },
        legend: { position: 'top', horizontalAlign: 'center' },
        colors: ['#727cf5'],
        xaxis: { categories: data.map((d) => d.name) },
        yaxis: { title: { text: 'Total Count' } },
    };
    const series = [
        {
            name: 'Total Count',
            data: data.map((d) => d.value),
        },
    ];
    return <Chart options={options} series={series} type="line" height={378} className="apex-charts mt-3" />;
};

export default GraphChartComponent;
